module.exports = __webpack_public_path__ + "icon-surface-color-circle.png?216aca010b1f83fec3b53b898837da51";